import {UserInterface} from './user.interface';

export class User implements UserInterface {
    roles?: Array<string>;
    id?: number;
    nom?: string;
    prenom?: string;
    username?: string;
    derniereConnexion?: string;
    forcageSubvention?: boolean;
    blogThemes?: Array<any>;
    loginTemporaire?: boolean;

    constructor({
                    roles = null,
                    id = null,
                    nom = null,
                    prenom = null,
                    username = null,
                    derniereConnexion = null,
                    forcageSubvention = null,
                    blogThemes = null,
                    loginTemporaire = null
                }: UserInterface) {
        this.id = id;
        this.roles = roles;
        this.nom = nom;
        this.prenom = prenom;
        this.username = username;
        this.derniereConnexion = derniereConnexion;
        this.forcageSubvention = forcageSubvention;
        this.blogThemes = blogThemes;
        this.loginTemporaire = loginTemporaire;
    }
}



// WEBPACK FOOTER //
// ./src/shared/models/user/user.model.ts